
import React, { useMemo } from "react";
import GenericTableFilter from "../../../components/common/GenericTableFilter";


const DealerWarehouseFilters = ({
  filterFields,
  columns,
  customFilterTypes,
  customFilterOptions,
  handleSearch,
  handleApplyFilters,
  handleResetFilters
}) => {
  const initialFilters = useMemo(() => {
    const f = {};
    (filterFields || []).forEach(ff => {
      if (ff.field === "isActive") f[ff.field] = true;
      else f[ff.field] = "";
    });
    return f;
  }, [filterFields]);

  return (
    <GenericTableFilter
      filterFields={filterFields}
      columns={columns}
      initialFilters={initialFilters}
      onSearch={handleSearch}
      onApplyFilters={handleApplyFilters}
      onResetFilters={handleResetFilters}
      customFilterTypes={customFilterTypes}
      customFilterOptions={customFilterOptions}
    />
  );
};

export default DealerWarehouseFilters;
